<template>
	<div>
		<PageBlocked v-if="isAccessDenied || isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null">
			<v-card class="user-profile__card pb-1" flat>
				<v-card-text>
					<div v-if="!!attendee">
            <UserInfo
                :follow_note="follow_note"
                @switchNoteFormModal="switchNoteFormModal"
                :isNoteSection="true"
                :userInfo="attendee.publicProfile"/>
					</div>

					<v-skeleton-loader
						v-else
						style="width: 100%"
						v-bind="attrs"
						type="card"
					/>
				</v-card-text>
				<div v-if="isShowNoteFormModal">
					<NoteFormModal
						v-on:closeModal="switchNoteFormModal"
						:show="isShowNoteFormModal"
						:id="profileInfo.block_data.user_id"
						:username="profileInfo.block_data.visible_username"
						:edit="!!follow_note"
						:note="follow_note || ''"
						userPage
					/>
				</div>
			</v-card>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import NoteFormModal from '../../components/Modals/NoteFormModal.vue'
import Block from '@/mixins/Block.js'
import Dwh from '@/mixins/Dwh'
import PageBlocked from '@/components/PageBlocked'
import _ from 'lodash'
import UserInfo from "@/components/User/UserInfo.vue";

export default {
	name: 'ProfilePage',
	mixins: [Block, Dwh],
	components: {
    UserInfo,
		NoteFormModal,
		PageBlocked,
	},
	computed: {
		...mapGetters('auth', ['profile', 'isAuthenticated']),
		...mapGetters('event', ['attendee','isLoading']),
		...mapGetters('settings', ['backUser']),
    ...mapGetters('app',['hasOtherProfileAccess']),
    isAccessDenied() {
      return !this.hasOtherProfileAccess
    },
    profileInfo() {
      return this.attendee?.publicProfile?.find(i => i.block_name === 'shortProfile') || null
    },
    followNote() {
      return this.attendee?.publicProfile?.find(i => i.block_name === 'noteBlock') || null
    },
	},
	methods: {
		...mapActions('event', ['getAttendee', 'clearAttendee']),
		...mapActions('app', ['setPageTitle']),
		switchNoteFormModal() {
			this.isShowNoteFormModal = !this.isShowNoteFormModal
		},
	},
	watch: {
		attendee(newValue, oldValue) {
			if ((newValue && !oldValue) || !_.isEqual(newValue, oldValue)) {
        this.follow_note = this.followNote?.block_data?.note || ''
				this.sendTrigger({
					category: 'Booth Staff',
					action: 'view_booth_staff_profile',
					module: 'Events',
					id1: newValue.user_id,
          id2: this.$route.query.event,
					title: newValue.visible_username,
				})
			}
		},
	},
	data() {
		return {
			successMessage: false,
			errorMessage: false,
			isShowNoteFormModal: false,
      follow_note:'',
			attrs: {
				class: 'mb-6 mt-6',
				elevation: 0,
			},
		}
	},
	created() {
		if ((this.$route.params.id || this.$route.query.id) && (!this.isBlocked || this.isBlocked === null)) {
      this.getAttendee(this.$route.params.id)
		}
	},
	mounted() {
		this.setPageTitle('User Profile')
	},
	beforeDestroy() {
		this.setPageTitle('')
    this.clearAttendee()
	},
}
</script>

<style lang="scss">
.user-profile {
	&__title {
		font-family: 'Inter', sans-serif;
		font-size: 24px;
		font-weight: 700;
		line-height: 29.26px;
		text-align: left;
	}

	&__card {
		background-color: transparent !important;
		max-width: 555px !important;
	}

	&__email-field {
		background-color: #f3f3f6;
		padding: 12px;
		border-radius: 8px;
	}
	&__phone-field {
		background-color: #f3f3f6;
		padding: 12px;
		border-radius: 8px;
	}

	&__header,
	&__note,
	&__section {
		position: relative;
		max-width: 555px !important;
		border-radius: 8px !important;
		margin-bottom: 8px;
		padding: 12px;
		background-color: #ffffff;
		font-family: 'Inter', sans-serif;
		border: 1px solid #e2e2e2;

		& > div:not(:last-child) > a.user-profile__network {
			margin-bottom: 12px;
		}
	}

	&__section-title {
		max-width: 555px !important;
		font-weight: 700;
		font-size: 18px;
		line-height: 100%;
		letter-spacing: 0;
		color: #002855;
		margin-bottom: 12px;
    &__edit{
      font-weight: 700;
      font-size: 18px;
      line-height: 100%;
      letter-spacing: 0;
      text-align: center;
      color: var(--text_button_tint)
    }
	}

	&__field-label {
		font-family: 'Inter', sans-serif;
		font-weight: 500;
		font-size: 14px;
		line-height: 100%;
		letter-spacing: 0;
		color: var(--accent-color);
		margin-right: 8px;
	}

	&__text,
	&__field-value {
    white-space: pre-line;
		font-family: 'Inter', sans-serif;
		font-weight: 400;
		font-size: 14px;
		line-height: 100%;
		letter-spacing: 0;
		color: #4a4a4a;
		word-break: break-all;
	}

	&__network {
		display: block;
		text-decoration: none;
		background-color: #f3f3f6;
		border-radius: 8px;
		padding: 12px;
		cursor: pointer;

		&-link {
			&-text {
				font-size: 14px;
				line-height: 17.07px;
				color: var(--accent-color);
				width: 100%;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 1;
				-webkit-box-orient: vertical;
			}
		}

		&-title {
			font-size: 14px;
			font-weight: 600;
			line-height: 22px;
			color: #4a4a4a;
			margin-bottom: 4px;
		}
	}

	&__header-content {
		display: flex;
		flex-wrap: nowrap;
	}

	&__details {
		font-family: 'Inter', sans-serif;
		display: flex;
		flex-direction: column;
		justify-content: center;
		gap: 8px;
		width: 100%;
	}

	&__name {
		font-weight: 700;
		font-size: 24px;
		line-height: 100%;
		letter-spacing: 0;
		color: var(--username-category-title);
	}

	&__company,
	&__position {
		width: 100%;
		font-weight: 400;
		font-size: 16px;
		line-height: 100%;
		letter-spacing: 0;
		color: var(--company-position-large);
		white-space: normal;
		word-break: break-word;
	}

	&__location {
		font-weight: 500;
		font-size: 13px;
		line-height: 100%;
		letter-spacing: 0;
		color: var(--location-color);
		display: flex;
		align-items: center;
		flex-wrap: nowrap;
	}

	&__phone-link {
		text-decoration: none;
		color: var(--ceil-detail-text-color);
	}
}
</style>
